import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { SortOption } from '../../../AccommodationsConsole.types';
import { SortComponent } from './SortComponent';
import { useTranslation } from '@shared/core';

interface Props {
  sortOption: SortOption;
  onSortChange: (sort: SortOption) => void;
}

const DeskTopListingsHeader: React.FC<Props> = ({ sortOption, onSortChange }) => {
  const { t } = useTranslation('accommodationsConsole');
  const listingTrans = t('listingsPanel');

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
    >
      <TextV2 typographyVariant="hed4">{listingTrans.title()}</TextV2>
      <SortComponent
        selectedValue={sortOption}
        onChange={onSortChange}
      />
    </Flex>
  );
};

export default DeskTopListingsHeader;
